/* Service that makes sure the user is an admin before allowing them to see
the admin settings or access any admin routes */

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class AdminGuard implements CanActivate {
  admin: boolean;

  constructor() { }

  checkAdmin(admin) {
    console.log("Changin the value of admin")
    this.admin = admin;
  }

  canActivate() {
    if (this.admin){
      console.log("Allowed access");
    } else {
      console.log("Not Allowed Access");
    }
    return this.admin;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-guard.service.ts